import {
  PBJ_AUDIT_MARKER_META,
  PBJ_AUDIT_PAY_TYPE_TITLES,
  PBJ_AUDIT_STATUS_META,
  PBJ_AUDIT_UNKNOWN_MARKER_META,
  PBJ_AUDIT_UNKNOWN_STATUS_META
} from './constants'

export default {
  getPbjAuditStatusMeta: () => status => PBJ_AUDIT_STATUS_META[status] ?? PBJ_AUDIT_UNKNOWN_STATUS_META,
  getPbjAuditMarkerMeta: () => marker => PBJ_AUDIT_MARKER_META[marker] ?? PBJ_AUDIT_UNKNOWN_MARKER_META,
  getPbjAuditActor: () => actor => actor?.name || actor?.associate_number || '—',
  getPbjAuditPayTypes: () => payTypes =>
    Array.isArray(payTypes) && payTypes.length
      ? payTypes.map(code => PBJ_AUDIT_PAY_TYPE_TITLES[code] ?? String(code)).join(', ')
      : '—'
}
